<template>
  <div class="cta-container">
    <div>
      <div class="cta-header">{{ heading }}
      </div>
      <div class="cta-subheader">{{ subHeading }}
      </div>
    </div>
    <div class="slot-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionBar',
  props: {
    heading: {
      type: String
    },
    subHeading: {
      type: String
    }
  }
}
</script>

<style scoped>
.cta-container {
  width: 100%;
  box-sizing: border-box;
  background-color: var(--cta-background-color);
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px;
}
.cta-header {
  font-size: 2.1em;
  line-height: 1.09;
  text-align: left;
  color: var(--cta-color);
  font-family: var(--title-font-stack);
  text-transform: uppercase;
  margin-left: 20px;
  padding-bottom: 5px;
}
.cta-subheader {
  font-size: .9em;
  line-height: 1.57143;
  text-align: left;
  color: var(--cta-color);
  margin-left: 20px;
}
.slot-container {
  margin-top: .8em;
  margin-bottom: .8em;
  margin-left: 20px;
}
.cta-container.gmc {
  align-items: center;
}
/* styles for xs screens go here */
/* styles for different screen widths follow */
@media only screen and (min-width: 576px) {
  .cta-header {
    font-size: 1.6em;
    line-height: .92;
  }
  .cta-subheader {
    font-size: 1.1em;
    line-height: 1;
  }
}
@media only screen and (min-width: 768px) {
}
@media only screen and (min-width: 992px) {
}
@media only screen and (min-width: 1200px) {
}
</style>
